import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMenu } from '../../hooks/useMenu';

import FundRetirementAmountForm from '../../components/Forms/FundRetirementAmountForm';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const FundRetirementAmount = () => {
  const { activeMenu, activeItem } = useMenu();
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('titleTagAmount', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <FundRetirementAmountForm nextPath={activeItem?.nextPath} />
    </OnBoardingContainer>
  );
};

export default FundRetirementAmount;
